module.exports = __webpack_public_path__ + "static/img/1.40c0d68.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/publish/1.png
// module id = b6n8
// module chunks = 1